var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tippy",rawName:"v-tippy"}],attrs:{"title":"Pause/Stop recording"},on:{"click":_vm.withConfirm}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faStop}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cfc050f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rep-call/toolbar/recording-button/recording-pause-stop-button.vue
// module id = qD1X
// module chunks = 1